<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-management-team-edit-user">
    <div class="div-header">
      <div class="div-title">Edit User</div>
      <div class="div-close">
        <el-button class="wy-blue-button close" size="mini" @click="handleClose">{{ $t('button.close') }}</el-button>
      </div>
    </div>

    <div ref="divBody" :rel="rerender" class="div-body">
      <div class="company-selection">
        <div v-if="companyList.length == 1" class="div-company">
          {{selectedCompany.name}}
        </div>
        <div v-else>
          <el-select v-model="selectedCompanyId" placeholder="Select a company" @change="handleCompanyChange">
            <el-option            
              v-for="company in companyList"
              :key="company.id"
              :label="company.name"
              :value="company.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <table border="0">
      <tr class="main-menu-item-row" valign="top">
        <td v-for="(aclItem, index) in selectedCompany.aclItems" :key="index">                  
          <el-collapse class="product-section-collapse" v-model="selectedSection" accordion @change="handleCollapseChange">
            <el-collapse-item class="product-section" :name="aclItem.label">
              <template slot="title">
                <span class="main-label-style">{{aclItem.label}} <span v-if="aclItem.label=='Others' && aclItem.subItems">({{aclItem.subItems.filter(subItem => { return subItem.aclInfo.filter(subAclInfo => subAclInfo.selected).length>0 }).length}})</span></span>
                <el-checkbox v-for="(aclInfo, aclIndex) in aclItem.aclInfo" v-model="aclInfo.selected" :indeterminate="aclInfo.indeterminate" :label="aclIndex" :key="aclIndex" @change="handleCheckItem($event, aclIndex, aclItem)">All ({{aclInfo.label}})</el-checkbox>
              </template>

              <div v-for="(subItem, index) in aclItem.subItems" :key="index">
                <div v-if="subItem.acl" class="sub-menu-container">
                  <div class="checkbox-flex-container">
                    <span class="sub-item-label">{{subItem.label}}</span>
                    <div class="checkbox-group">
                      <el-checkbox v-for="(subAclInfo, subAclIndex) in subItem.aclInfo" v-model="subAclInfo.selected" :label="subAclInfo.code" :key="subAclInfo.code" @change="handleCheckSubItem($event, subAclIndex, subItem, aclItem)">{{subAclInfo.label}}</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </td>
      </tr>
      </table>
    </div>

    <div class="div-footer">
      <el-button class="wy-blue-button edit" size="mini" @click="handleUpdate()">Update</el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default Vue.extend({
  name: 'wy-management-team-edit-user',
  props: ["controller"],
  data() {
    return {
      loading: false,
      rerender: false,
      companyList: null,
      selectedCompanyId: null,
      selectedSection: null
    }
  },

  computed: {
    ...mapGetters(['authUser', 'config']),

    selectedCompany() {
      return this.companyList.find(comp => comp.id == this.selectedCompanyId);
    },

    // selectedAclItems() {
    //   this.rerender; // don't remove this line
    //   let itemPerms = this.companyList.find(comp => comp.id == this.selectedCompanyId).aclItems.reduce((list, aclItem) => {
    //     let subItemPerms = aclItem.subItems.reduce((sublist, subItem) => {
    //       sublist.push(...subItem.aclInfo.filter(el => el.selected).map(info => info.code));
    //       return sublist;
    //     }, []);
        
    //     list.push(...subItemPerms);
    //     return list;
    //   }, []);
      
    //   return itemPerms;
    // }
  },

  methods: {
    ...mapActions(['updateUserAccessList']),

    handleClose() {
      this.controller.showUserEdit = false;
    },

    handleUpdate() {
      let permissionMap = {};
      this.controller.selectedUser.accessList.forEach(access => {
        // prepare company selected acl
        const comp = this.companyList.find(comp => comp.id==access.companyId)
        if(comp) {
          let itemPerms = comp.aclItems.reduce((list, aclItem) => {
            let itemPerms = aclItem.aclInfo.filter(el => el.selected).map(info => info.code)
            list.push(...itemPerms);

            let subItemPerms = aclItem.subItems.reduce((sublist, subItem) => {
              sublist.push(...subItem.aclInfo.filter(el => el.selected).map(info => info.code));
              return sublist;
            }, []);
            
            list.push(...subItemPerms);
            return _.uniq(list);
          }, []);
          access.permissions = itemPerms;
          permissionMap[access.companyId] = itemPerms;
        }
      })
      this.controller.selectedUser.permissionMap = permissionMap;
      this.updateUserAccessList({
        userId: this.controller.selectedUser.id,
        payload: {
          accessList: this.controller.selectedUser.accessList
        }
      });
      this.handleClose();
    },

    updateTopLevelCheckbox(aclItem) {
      aclItem.aclInfo.map((aclItemInfo, index) => {
        const hasSelectedItems = aclItem.subItems.find(subItem => subItem.aclInfo.find((info, infoIndex) => (info.selected && infoIndex==index)));
        const hasNoSelectedItems = aclItem.subItems.find(subItem => subItem.aclInfo.find((info, infoIndex) => (!info.selected && infoIndex==index)));
        aclItemInfo.selected = (hasSelectedItems!=null && hasNoSelectedItems==null);
        aclItemInfo.indeterminate = (hasSelectedItems!=null && hasNoSelectedItems!=null);
      })
    },

    handleCollapseChange() {
      this.$refs.divBody.style.overflowY = "hidden";
      setTimeout(() => {
        this.$refs.divBody.style.overflowY = "auto";
      }, 500);
    },

    handleCompanyChange() {
      //this.selectedSections = [];
    },

    handleCheckItem(checked, index, aclItem) {
      this.selectedSection = aclItem.label;

      let updateIndexes = [index];
      if(checked) {
        if(index == 1) {
          updateIndexes.push(0);
        }
      }
      else {
        if(index == 0) {
          updateIndexes.push(1);
        }
      }

      aclItem.subItems.reduce((list, item) => {
        const aclCodes = item.aclInfo.filter((aclInfo, aclIndex) => (aclInfo && updateIndexes.includes(aclIndex))).map(el => {
          el.selected = checked;
          return el.code;
        });
        list.push(...aclCodes);
        return list;
      }, []);

      if(aclItem.subItems && aclItem.subItems.length == 0) {
        aclItem.aclInfo[index].selected = checked;
      }
      else {
        this.updateTopLevelCheckbox(aclItem, index);
      }
      this.rerender = !this.rerender;
    },

    // eslint-disable-next-line no-unused-vars
    handleCheckSubItem(checked, index, subItem, aclItem) {
      if(checked) {
        if(subItem.aclInfo.length > 0) {
          if(index == 1) {
            subItem.aclInfo[0].selected = true;
          }
        }
      }
      else {
        if(index == 0 && subItem.aclInfo.length > 1) {
          subItem.aclInfo[1].selected = false;
        }
      }

      this.updateTopLevelCheckbox(aclItem, index);
      this.rerender = !this.rerender;
    }
  },

  async created() {
    const navMenuItems = JSON.parse(JSON.stringify(this.config.navMenu.items));
    navMenuItems.push({
      "label": "Others", "productCode": 3000, "acl": {},
      "subItems": [
        {"label": "Alert Notifications", "acl": {"3001": ""}}
      ]
    });

    let permissionMap = JSON.parse(JSON.stringify(this.controller.selectedUser.permissionMap));
    this.companyList = this.controller.accessibleCompanies;
    if(this.controller.selectedUser.defaultCompanyId) {
      this.selectedCompanyId = this.controller.selectedUser.defaultCompanyId;
    }
    else if(this.companyList.length > 0) {
      this.selectedCompanyId = this.companyList[0].id;
    }

    this.companyList.forEach(company => {
      company.productList = [];
      company.aclItems = [];

      let companyAclItems = [];
      company.products.forEach(productCode => {
        let productMap = []
        // prepare permissions for the company products
        let permissions = this.controller.permissionList.filter(el => el.groupCode == productCode);
        permissions.forEach(permission => {
          if(!productMap[permission.group]) productMap[permission.group] = [];
          productMap[permission.group].push(permission);
        })

        Object.keys(productMap).forEach(group => {
          let permissionList = productMap[group];
          company.productList.push({
            name: group,
            permissionList: permissionList.sort()
          });
        })

        const menuItems = navMenuItems.find(item => item.productCode==productCode);
        if(menuItems) {
          const aclItem = JSON.parse(JSON.stringify(menuItems));
          aclItem.aclInfo = [];

          // prepare sub-level acl objects
          aclItem.subItems.forEach(subItem => {
            subItem.aclInfo = [];
            Object.keys(subItem.acl).forEach(key => {          
              subItem.aclInfo.push({
                code: parseInt(key),
                label: subItem.acl[key],
                selected: permissionMap[company.id].includes(parseInt(key))
              });
            });
          });

          // prepare top-level acl objects
          Object.keys(aclItem.acl).forEach((key, index) => {          
            if(aclItem.subItems && aclItem.subItems.length == 0) {
              aclItem.aclInfo.push({
                code: parseInt(key),
                label: aclItem.acl[key],
                selected: permissionMap[company.id].includes(parseInt(key)),
                indeterminate: false,
              });
            }
            else {
              const hasSelectedItems = aclItem.subItems.find(subItem => subItem.aclInfo.find((info, infoIndex) => (info.selected && infoIndex==index)));
              const hasNoSelectedItems = aclItem.subItems.find(subItem => subItem.aclInfo.find((info, infoIndex) => (!info.selected && infoIndex==index)));

              aclItem.aclInfo.push({
                code: parseInt(key),
                label: aclItem.acl[key],
                selected: (hasSelectedItems!=null && hasNoSelectedItems==null),
                indeterminate: (hasSelectedItems!=null && hasNoSelectedItems!=null),
              });
            }
          });

          // if(!this.selectedSections.includes(aclItem.label)) {
          //   this.selectedSections.push(aclItem.label);
          // }

          companyAclItems.push(aclItem);
        }
      });

      navMenuItems.map(item => {
        const foundItem = companyAclItems.find(aclItem => aclItem.label==item.label);
        if(foundItem) {
          company.aclItems.push(foundItem);
        }
      });
    })    
  },
});
</script>

<style lang="scss">
.wy-management-team-edit-user {
  height: 100%;
  padding: 10px;  
  .main-label-style{
    width: 242px;
    margin-right: 15px;
  }
  .sub-item-label{
    width: 208px;
    margin-left: 15px;
  }
  .main-menu-item-row {
    display: flex;
    flex-direction: column;
  }
  .sub-menu-container {
    margin-left: 15px;
    margin-bottom: 10px;

    .el-checkbox {
      margin-right: 57px;
    }
  }
  .checkbox-group {
    margin-left: 33px;
  }
  .checkbox-flex-container {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .product-section-collapse {
    height: 100%;
    border-top: none !important;
    border-bottom: none !important;
    .el-collapse-item__header {
      font-weight: 550 !important;
      height: 17px;
      //width: 819px;
      background-color: none !important;
      color: var(--site-font-tertiary-color);
      font-size: 14.22px;
      border-bottom: 1px solid #CAD2DA !important;
      font-weight: 400;
      padding: 18px 6px 18px 15px;
      cursor: pointer;
      margin-bottom: 0px;
    }
    .el-collapse-item__header:hover{
      background: #F9F9F9;
    }

    .el-collapse-item__wrap {
      border-bottom: none !important;
      margin-right: 5px;
      box-sizing: unset !important;
      will-change: unset !important;
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #CAD2DA;
        border-radius: 5px;
      }
    }
    .el-icon-arrow-right:before {
      content: "";
      background-image: url('../../assets/icons/icon_unclassified_msg_arrow.svg');
      background-size: 60%;
      background-position-x: 1px;
      background-position-y: 6px;
      background-repeat: no-repeat;
      height: 16px;
      width: 16px;
      display: inline-block
    }
    .el-collapse-item__arrow.is-active {
      transform: rotate(180deg) !important;
    }
    .el-collapse-item__content {
      padding-bottom: 0em !important;
      height: 100%;
      position: relative;
      right: -1px;
      overflow: hidden;
      &::-webkit-scrollbar {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#FFFFFF;
      }
      &::-webkit-scrollbar:vertical {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
      }

      .el-checkbox__label {
        position: inherit;
        color: var(--site-font-drop-down-secondary-color);
      }
    }
  }

  .div-header {
    height: 50px;
    padding: 0px 0px 0px 15px;

    .div-title {
      display: inline-block;
      padding: 10px 10px 0px 10px;
      font-size: 16px;
      font-weight: 600;
    }
  }
  
  .div-body {
    height: calc(100% - 140px);
    margin-bottom: 20px;
    overflow-y: hidden !important;
    padding-left: 15px;
    padding-right: 15px;

    > table {
      width: 100%;
    }

    .company-selection {
      margin-left: 10px;
      margin-bottom: 15px;
      .el-select {
        width: 400px;

        .el-input__inner {
          font-size: 20px;
        }
      }

      .div-company {
        font-size: 20px;
        border-bottom: 1px solid #e8e8e8;
        width: 99.5%;
        padding-bottom: 10px;
      }
    }
  }

  .div-close {
    float: right;
    padding: 0px 9px 0px 0px;
    .el-button.close {
      background-color: #FFF;
      -webkit-box-shadow: unset;
      box-shadow: unset;
      color: var(--site-font-primary-color);
      font-size: 15px;
      padding: 7px 20px 7px 20px;
    }
    .el-button.close:focus {
      outline: none;
      color: #214586;
    }
  }
  
  .el-checkbox-group {
    margin-bottom: -10px;
    margin-top: -5px;
    margin-left: 32px;
    span.el-checkbox__label {
      color: #214586;
    }
    span.el-checkbox__input {
      line-height: 0px;
      height: fit-content;
    }
    span.el-checkbox__input:focus-within {
        outline: none;
        line-height: 0px;
        box-shadow: 0px 0px 10px #0a21f3a3;
    } 
    // span.el-checkbox__inner:focus-within {
    //   outline: none;
    //   box-shadow: 0px 0px 10px #0a21f3a3;
    // } 
  }

  .div-footer {
    text-align: right;
    margin-right: 5px;

    button.el-button.wy-blue-button.edit.el-button--default.el-button--mini:focus {
      outline: none;
      box-shadow: 0px 0px 10px #0a21f3a3;
    }
  }
}
</style>
